import { t } from 'i18next';

import { LOGOUT_URL } from '../config'

const LOGIN_STATUS_URL = '/quake/get-login-status'
const LAST_LOGIN_STATUS_ACTIVE_TIME_IN_MS = 2000  // 2 sec


function _sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}


export const _getLoginStatus = async () => {
  const config = {
    method: 'GET',
  }
  const response = await window.fetch(LOGIN_STATUS_URL, config)
  // return response
  if (response.status === 200) {
    return await response.json()
  } else {
    return { status: response.status }
  }
  // throw new Error(response.statusText)
}


export const getLoginStatus = (() => {
  // let lastSuccessfulLoginTime = 0
  // let lastSuccessfulLoginStatus = {}
  let lastFetchTime = 0
  let lastFetchResult = {}
  let isGettingLoginStatus = false;
  return async() => {
    const now = Date.now()
    if (isGettingLoginStatus) {
      while (isGettingLoginStatus && (lastFetchTime < now)) {
        await _sleep(500)
      }
      return lastFetchResult
    } else if ((lastFetchTime + LAST_LOGIN_STATUS_ACTIVE_TIME_IN_MS >= now) && (lastFetchResult.status === 200)) {
      return lastFetchResult
    }
    
    isGettingLoginStatus = true;
    let loginStatus = {}
    try {
      loginStatus = await _getLoginStatus()
    } catch (error) {
      isGettingLoginStatus = false;
      alert(t('others.failedToVerifyUser') + '\r\n' + t('form.message.contactAdministrator'))
      return
    }
    isGettingLoginStatus = false;
    lastFetchTime = Date.now()
    lastFetchResult = { ...loginStatus }
    return loginStatus
  }
})()


export const logout = async () => {
  const config = {
    method: 'GET',
  }
  const queryString = `?redirect=${window.location.href}`
  try {
    const response = await window.fetch(LOGOUT_URL + encodeURIComponent(queryString), config)
    return response
  } catch (err) {
    return {
      ok: false,
      statusText: (err && err.message) ? err.message : err
    }
  }
}